<template>
  <div
    ref="shellRef"
    v-bind="attrs"
    class="empty-select-shell tw-relative tw-flex tw-w-full tw-items-center tw-overflow-hidden tw-border tw-border-gray-medium tw-bg-white tw-text-xs tw-text-gray-dark hover:tw-border-blue focus:tw-border-blue"
    :class="{
      'tw-cursor-pointer': !props.readonly,
      'tw-border-dashed': props.readonly,
      'empty-select-shell--readonly': props.readonly,
      'tw-border-red': !!errorMessage,
    }"
    :tabindex="props.readonly ? undefined : 0"
  >
    <span v-if="prependLabel" class="empty-select-shell__prepend-label">
      {{ prependLabel }}
    </span>
    <span class="tw-flex-1 tw-px-2">
      <slot />
    </span>
  </div>
  <span
    v-if="errorMessage && !props.errorOutlineOnly"
    class="form-input__error-message"
  >
    {{ errorMessage }}
  </span>
</template>

<script setup lang="ts">
import { ref, useAttrs } from 'vue';

// Since we use Vue 3 fragments (multiple root elements), we need to handle attrs manually
defineOptions({
  inheritAttrs: false,
});
const attrs = useAttrs();

interface Props {
  isOpen?: boolean;
  hideChevron?: boolean;
  errorMessage?: string;
  errorOutlineOnly?: boolean;
  prependLabel?: string;
  readonly?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isOpen: false,
});

const shellRef = ref<HTMLElement | null>(null);

// Expose the focusable shell element for parent components that need focus management
defineExpose({
  shellRef,
  focus: () => shellRef.value?.focus(),
});
</script>

<style lang="scss" scoped>
.empty-select-shell {
  border-radius: 0.25rem;
  min-height: 2rem;

  &:focus {
    outline: none !important;
  }

  &__prepend-label {
    @apply tw-font-bold tw-uppercase tw-px-3 tw-flex tw-items-center tw-justify-center tw-text-gray-medium-dark tw-bg-gray-medium-light tw-mr-2;
    border-radius: calc(0.25rem - 1px) 0 0 calc(0.25rem - 1px);
    height: calc(2rem - 2px);
    font-size: 10px;
  }
}
</style>
